<div *ngIf="loaderPayment$ | async" class="overlay">
    <div>
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" value="50"></mat-progress-spinner>
    </div>
</div>

<div class="col_6">

    <form [formGroup]="form" (ngSubmit)="formService.submit()">
        <div class="page_title">
            <div class="row marges">
                <div class="col y_items_center">
                    <h1 class="title">{{ 'commission.payment.title.value' | translate }}</h1>
                </div>

            </div>
        </div>

        <ng-container *ngIf="invoice">

            <div class="row marges ligne_form">

                <div class="col_12">
                    <div class="form-group">
                        <p class="read">
                            <strong>{{ 'commission.amount.value' | translate  }} : </strong>{{ parsePrice(invoice.amount + invoice.amountVat) }}
                        </p>
                    </div>
                </div>

            </div>

            <div class="row marges ligne_form">

                <div class="col_12 y_items_center recap_payment">
                    <div class="form-group ">

                        <table>

                            <thead>
                                <tr>
                                    <td class="total" style="font-weight: bold">{{'description.value' | translate }} </td>
                                    <td *ngIf="rateFieldsDisplayed" class="total" style="font-weight: bold">{{'price.ht.unit.initial.value' | translate }} </td>
                                    <td *ngIf="rateFieldsDisplayed" class="total" style="font-weight: bold">{{'rate.exchange.value' | translate }} </td>
                                    <td class="total" style="font-weight: bold">{{'price.ht.unit.value' | translate }} </td>
                                    <td class="total" style="font-weight: bold">{{'vat.byPercent.value' | translate }} </td>
                                    <td class="total" style="font-weight: bold">{{'vat.byCurrency.value' | translate: { symbol: invoice.currency.symbol } }} </td>
                                    <td class="total" style="font-weight: bold">{{'price.ttc.value' | translate }} </td>
                                </tr>
                            </thead>

                            <ng-container *ngFor="let row of invoice.rows">

                                <tr>
                                    <td>{{ row.title }}</td>
                                    <td *ngIf="rateFieldsDisplayed" [ngStyle]="{ 'text-align' : (row.initialCurrency.symbol === invoice.currency.symbol) ? 'center' : 'initial' }">{{ (row.initialCurrency.symbol === invoice.currency.symbol) ? '-' : (parsePrice(row.initialPrice, row.initialCurrency)) }}</td>
                                    <td *ngIf="rateFieldsDisplayed" [ngStyle]="{ 'text-align' : (row.initialCurrency.symbol === invoice.currency.symbol) ? 'center' : 'initial' }">{{ (row.initialCurrency.symbol === invoice.currency.symbol) ? '-' : row.rate }}</td>
                                    <td>{{ parsePrice(row.price) }}</td>
                                    <td>{{ parsePercent(row.vatPercent) }}</td>
                                    <td>{{ parsePrice(row.vatAmount) }}</td>
                                    <td>{{ parsePrice(row.price + row.vatAmount) }}</td>
                                </tr>

                            </ng-container>

                            <tr style="height: 24px"></tr>

                            <!-- Total HT -->

                            <tr>
                                <td [colSpan]="columnCount - 1" class="total" style="font-weight: bold">{{'price.ht.total.value' | translate}} </td>
                                <td>{{ parsePrice(invoice.amount) }}</td>
                            </tr>

                            <!-- Total TVA -->

                            <tr>
                                <td [colSpan]="columnCount - 1" class="total" style="font-weight: bold">{{'price.vat.total.value' | translate: { parsedPercent: parsePercent(invoice.vatPercent) } }} </td>
                                <td>{{ parsePrice(invoice.amountVat) }}</td>
                            </tr>

                            <!-- Total TTC -->

                            <tr>
                                <td [colSpan]="columnCount - 1" class="total" style="font-weight: bold">{{'price.ttc.total.value' | translate}} </td>
                                <td>{{ parsePrice(invoice.amount + invoice.amountVat) }}</td>
                            </tr>

                        </table>
                    </div>
                </div>

            </div>

        </ng-container>

        <ng-container *ngIf="isPaymentDataRequired">

            <div class="col_content y_items_center">
                <div class="without_payment_information x_center">
                    <p [innerHTML]="'commission.payment.description.value' | translate"></p>
                </div>
            </div>

            <div class="payment_form">

                <div class="row marges payment_methods x_center">
                    <div class="col_content">
                        <span class="method_item cb"></span>
                    </div>
                    <div class="col_content">
                        <span class="method_item visa"></span>
                    </div>
                    <div class="col_content">
                        <span class="method_item mastercard"></span>
                    </div>
                    <div class="col_content">
                        <span class="method_item maestro"></span>
                    </div>
                </div>

            </div>

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <input type="text" number-card class="form-control" formControlName="cardNumber" id="cardNumber" required="required" [control]="form.get('cardNumber')">
                        <label for="cardNumber">{{'payment.fields.cardNumber.value' | translate}}</label>
                        <mat-error
                            *ngIf="form.get('cardNumber').errors && (form.get('cardNumber').dirty || form.get('cardNumber').touched)">
                            <div class="invalid-feedback">
                                <div *ngIf="form.get('cardNumber').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                <div *ngIf="form.get('cardNumber').errors.invalidNUmberCard">{{ 'payment.fields.error.invalidNUmberCard.value' | translate }}</div>

                            </div>
                        </mat-error>
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_6">
                    <div class="form-group">
                        <input type="text" class="form-control" date-card formControlName="cardExpirationDate" id="cardExpirationDate" required="required" [control]="form.get('cardExpirationDate')">
                        <label for="cardExpirationDate">{{'payment.fields.cardExpirationDate.value' | translate}}</label>
                        <mat-error
                            *ngIf="form.get('cardExpirationDate').errors && (form.get('cardExpirationDate').dirty || form.get('cardExpirationDate').touched)">
                            <div class="invalid-feedback">
                                <div *ngIf="form.get('cardExpirationDate').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                <div *ngIf="form.get('cardExpirationDate').errors.invalidFormatDate">{{ 'payment.fields.error.invalidFormatDate.value' | translate }}</div>
                                <div *ngIf="form.get('cardExpirationDate').errors.invalidDatePast">{{ 'payment.fields.error.invalidDatePast.value' | translate }}</div>

                            </div>
                        </mat-error>
                    </div>
                </div>
                <div class="col_6">
                    <div class="form-group">
                        <input type="text" class="form-control" cvv-card formControlName="cardCvx" id="cardCvx" required="required" [control]="form.get('cardCvx')">
                        <label for="cardCvx">{{'payment.fields.cardCvx.value' | translate}}</label>
                        <mat-error
                            *ngIf="form.get('cardCvx').errors && (form.get('cardCvx').dirty || form.get('cardCvx').touched)">
                            <div class="invalid-feedback">
                                <div *ngIf="form.get('cardCvx').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                <div *ngIf="form.get('cardCvx').errors.invalidFormatCvv">{{ 'payment.fields.error.invalidFormatCvv.value' | translate }}</div>
                            </div>
                        </mat-error>
                    </div>
                </div>
            </div>

        </ng-container>

        <div class="row marges ligne_form x_center">

            <ng-container *ngIf="!isPaymentDataRequired">

                <div class="col_content y_items_center">
                    <div class="without_payment_information x_center">
                        <p [innerHTML]="'commission.without_card_registration.value' | translate"></p>
                    </div>
                </div>

            </ng-container>

            <div class="col_content y_items_center">

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit" [disabled]="!isSubmitAllowed">
                    {{ 'validationAndPayment.action.value'|translate }}
                </button>
            </div>

        </div>

    </form>
</div>
